import { TMakeBreadcrumbFn } from './composeMakeBreadcrumb';

export const makeInputBreadcrumb: TMakeBreadcrumbFn = (breadcrumb, hint?) => {
  const result = { ...breadcrumb };

  if (breadcrumb.category === 'ui.input' && hint) {
    const { target } = hint.event as { target: HTMLInputElement };

    if (!target) return result;

    const breadcrumbData = {
      ...(target.getAttribute('aria-label') && {
        ariaLabel: target.getAttribute('aria-label'),
      }),
      ...(target.id && { fieldId: target.id }),
      ...(target.getAttribute('data-testid') && {
        dataTestId: target.getAttribute('data-testid'),
      }),
      ...(target.tagName === 'INPUT' &&
        target.name && { inputName: target.name }),
    };

    result.data = breadcrumbData;
  }

  return result;
};
